import React, { useRef } from 'react';
import { FaFacebook, FaGithub, FaLinkedin, FaWhatsapp } from 'react-icons/fa';
import { MdOutlineFileDownload } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';

const ReactPdf = () => {
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: 'Shakil Ahamed',
        removeAfterPrint: false,
    })
    return (
        <div>
            <div ref={componentRef}>
                <div className='text-center'>
                    <h1 className='text-4xl font-bold mb-8'>Shakil Ahamed</h1>
                    <div className='flex flex-wrap justify-center gap-x-4 w-3/4 mx-auto'>
                        <p className='flex gap-x-2'>
                            <span className='font-bold'>Date of birth:</span>
                            <span className='opacity-80 font-medium'>20/03/2001</span>
                        </p>
                        <p className='flex gap-x-2'>
                            <span className='font-bold'>Nationality:</span>
                            <span className='opacity-80 font-medium'>Bangladeshi</span>
                        </p>
                        <p className='flex gap-x-2'>
                            <span className='font-bold'>Address:</span>
                            <span className='opacity-80 font-medium'>Dhanmondi, Dhaka, Bangladesh</span>
                        </p>
                        <p className='flex gap-x-2'>
                            <span className='font-bold'>Phone number:</span>
                            <span className='opacity-80 font-medium'>+880 1794267010</span>
                        </p>
                        <p className='flex gap-x-2'>
                            <span className='font-bold'>Email address:</span>
                            <Link className='opacity-80 font-medium' to='https://mail.google.com/mail/u/0/#inbox?compose=CllgCJvrbwXfbLjZzZmCtlpmXlWLJWwHDBBpFtTmdMcdCPlVtJdfgbVszKDpzcbrMSgKdCZkVJV' target='_blank'>web.shakil10@gmail.com</Link>
                        </p>
                        <p className='flex gap-x-2'>
                            <span className='font-bold'>Portfolio:</span>
                            <Link className='opacity-80 font-medium btn-link text-teal-300 no-underline' to='https://sakil10.netlify.app/' target='_blank'>https://sakil10.netlify.app/</Link>
                        </p>
                    </div>
                </div>
                <div className='my-20'>
                    {/* Profile */}
                    <div className='border-y border-teal-300 flex gap-5 '>
                        <h1 className='text-2xl font-bold border-e-2 border-teal-300 p-5 w-[300px]'>Profile</h1>
                        <p className='p-5 opacity-80 w-full'>Highly skilled MERN Stack Web Developer with a proven track record in developing innovative and user-friendly web applications. Possess strong proficiency in JavaScript, React, Node.js, and MongoDB. Excellent problem-solving and communication skills, with a keen eye for detail. Committed to delivering quality solutions that exceed client expectations. Seeking to leverage my expertise and contribute to a dynamic and fast-growing organization.
                        </p>
                    </div>

                    {/* Educatoion */}
                    <div className='border-y border-teal-300 flex gap-5'>
                        <h1 className='text-2xl font-bold border-e-2 border-teal-300 p-5 w-[300px]'>Educatoion</h1>
                        <div className='p-5 opacity-80 w-full'>
                            <h1 className='text-xl font-medium'>Computer Science & Engineering (CSE) | B.Sc</h1>
                            <h1 className='text-xl font-medium'>Dhaka International University</h1>
                            <p className='flex gap-10 mt-2 font-mono opacity-80'>
                                <span>01/2022 - 01/2026</span>
                                <span>DHAKA, BANGLADESH</span>
                            </p>
                        </div>
                    </div>

                    {/* Skills */}
                    <div className='border-y border-teal-300 flex gap-5'>
                        <h1 className='text-2xl font-bold border-e-2 border-teal-300 p-5 w-[300px]'>Skills</h1>
                        <div className='p-5 opacity-80 grid grid-cols-2 lg:flex flex-wrap gap-x-8 gap-y-5 w-full'>

                            <p className='font-bold'>HTML</p>
                            <p className='font-bold'>CSS</p>
                            <p className='font-bold'>Bootstrap</p>
                            <p className='font-bold'>TailwindCSS</p>
                            <p className='font-bold'>JavaScript</p>
                            <p className='font-bold'>TypeScript</p>
                            <p className='font-bold'>ES6</p>
                            <p className='font-bold'>Git</p>
                            <p className='font-bold'>React.js</p>
                            <p className='font-bold'>Angular</p>
                            <p className='font-bold'>Node.js</p>
                            <p className='font-bold'>Express.js</p>
                            <p className='font-bold'>Firebase</p>
                            <p className='font-bold'>MongoDB</p>
                            <p className='font-bold'>Flutter</p>
                        </div>
                    </div>

                    {/* Projects */}
                    <div className='border-y border-teal-300 flex gap-5'>
                        <h1 className='text-2xl font-bold border-e-2 border-teal-300 p-5 w-[300px]'>Projects</h1>
                        <div className='p-5 w-full'>
                            <div className='mb-8'>
                                <div className='mb-4 lg:mb-2 flex flex-col justify-between'>
                                    <div>
                                        <h1 className='text-xl font-bold'>ABC School</h1>
                                        <p className='opacity-80 text-sm'>FULL STACK SITE</p>
                                    </div>
                                    <div className='flex flex-col lg:flex-row gap-2 lg:gap-5'>
                                        <Link to='https://school-4c2d7.web.app/' className='btn-link text-teal-300'>Live Site</Link>
                                        <Link to='https://github.com/Sakil71/School-Client' className='btn-link text-teal-300'>Client Site</Link>
                                        <Link to='https://github.com/Sakil71/School-Server' className='btn-link text-teal-300'>Server Site</Link>
                                    </div>
                                </div>
                                <ul className='list-disc opacity-80 pl-5'>
                                    <li>New students apply for admission</li>
                                    <li>Recent events show on home page according to pagination</li>
                                    <li> Login and register page connected with firebase</li>
                                    <li>There is a notice board</li>
                                    <li>There is a dashboard route, and only academic information show everyone</li>
                                    <li>Admin role: students list, confirm students, delete students, make admin, delete admin, add teacher, add notice etc</li>
                                </ul>
                            </div>
                            <div className='mb-8'>
                                <div className='mb-4 lg:mb-2 flex flex-col justify-between'>
                                    <div>
                                        <h1 className='text-xl font-bold'>Travellers</h1>
                                        <p className='opacity-80 text-sm'>FRONTEND SITE</p>
                                    </div>
                                    <div className='flex flex-col lg:flex-row gap-2 lg:gap-5'>
                                        <Link to='https://travellers08.netlify.app/' className='btn-link text-teal-300'>Live Site</Link>
                                        <Link to='https://github.com/Sakil71/React-Project/tree/main/travellers-client' className='btn-link text-teal-300'>Client Site</Link>
                                    </div>
                                </div>

                                <ul className='list-disc opacity-80 pl-5'>
                                    <li> There is a login and registration page</li>
                                    <li>This site focused on tourism</li>
                                    <li> An user explore tourist spot for visit</li>
                                    <li>User can book their date for a guide</li>
                                </ul>
                            </div>
                            <div className='mb-8'>
                                <div className='mb-4 lg:mb-2 flex flex-col justify-between'>
                                    <div>
                                        <h1 className='text-xl font-bold'>World University</h1>
                                        <p className='opacity-80 text-sm'>FRONTEND SITE</p>
                                    </div>
                                    <div className='flex flex-col lg:flex-row gap-2 lg:gap-5'>
                                        <Link to='https://varsity-campus.netlify.app/' className='btn-link text-teal-300'>Live Site</Link>
                                        <Link to='https://github.com/Sakil71/Varsity-Campus' className='btn-link text-teal-300'>Client Site</Link>
                                    </div>
                                </div>
                                <ul className='list-disc opacity-80 pl-5'>
                                    <li>Here added University courses and Varsity campus location</li>
                                    <li>Added varcity's facilities taht they provided</li>
                                    <li>Added Students feedback and blog page</li>
                                    <li>There is a contact route, and here added varsity's live location</li>
                                    <li>Added varsity's contact address, and contact form</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Work Experience */}
                    <div className='border-y border-teal-300 flex gap-5'>
                        <h1 className='text-2xl font-bold border-e-2 border-teal-300 p-5 w-[300px]'>Work Experience</h1>
                        <div className='p-5 w-full'>
                            <h1 className='text-xl mb-2 font-bold'>MERN Stack Web Developer</h1>
                            <ul className='list-disc opacity-80 pl-5'>
                                <li>3+ years web development experince</li>
                                <li>Developed and maintained responsive web applications using the MERN stack, resulting in improved user experience and increased customer satisfaction.</li>
                            </ul>
                        </div>
                    </div>

                    {/* Language */}
                    <div className='border-y border-teal-300 flex gap-5'>
                        <h1 className='text-2xl font-bold border-e-2 border-teal-300 py-10 px-5 w-[300px]'>Language</h1>
                        <div className=' py-10 px-5 flex flex-col lg:flex-row gap-3 lg:gap-10 w-full'>
                            <div className='w-full'>
                                <h1 className='font-medium mb-2'>Bangla</h1>
                                <div className='bg-teal-400 h-2 w-full relative'>
                                    <div className='bg-black h-full w-4 absolute right-0' title='100%'></div>
                                </div>
                            </div>
                            <div className='w-full'>
                                <h1 className='font-medium mb-2'>English</h1>
                                <div className='bg-teal-400 h-2 w-full relative'>
                                    <div className='bg-black h-full w-4 absolute left-[80%]' title='80%'></div>
                                </div>
                            </div>
                            <div className='w-full'>
                                <h1 className='font-medium mb-2'>Hindi</h1>
                                <div className='bg-teal-400 h-2 w-full relative'>
                                    <div className='bg-black h-full w-4 absolute left-1/2' title='50%'></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Strengths */}
                    <div className='border-y border-teal-300 flex gap-5'>
                        <h1 className='text-2xl font-bold border-e-2 border-teal-300 py-10 px-5 w-[300px]'>Strengths</h1>
                        <div className='py-10 px-5 flex flex-wrap font-medium gap-x-20 gap-y-4 text-lg w-full'>
                            <h1 className='border-b'>Technical Skills</h1>
                            <h1 className='border-b'>Problem Solving</h1>
                            <h1 className='border-b'>Communication</h1>
                            <h1 className='border-b'>Teamwork</h1>
                            <h1 className='border-b'>Adaptability</h1>
                            <h1 className='border-b'>Time Management</h1>
                        </div>
                    </div>

                    {/* Courses */}
                    <div className='border-y border-teal-300 flex gap-5'>
                        <h1 className='text-2xl font-bold border-e-2 border-teal-300 p-5 w-[300px]'>Courses</h1>
                        <div className='w-full p-5'>
                            <h1 className='text-xl font-bold'>Complete Web Development Course With Jhankar Mahbub</h1>
                            <h1 className='text-xl font-bold mb-2'>Programming Hero</h1>
                            <p className='font-medium'>Completed date: <span className='opacity-80'>04/12/2022</span></p>
                            <p className='font-medium opacity-80'>ONLINE</p>
                            <Link className='btn-link text-teal-300 no-underline'>https://web.programming-hero.com/course-summery/web-6</Link>
                        </div>
                    </div>

                    {/* Social Media */}
                    <div className='border-y border-teal-300 flex gap-5'>
                        <h1 className='text-2xl font-bold border-e-2 border-teal-300 p-5 w-[300px]'>Social Media</h1>
                        <div className='w-full p-5 flex flex-wrap gap-x-10 gap-y-5'>
                            <Link to='https://www.facebook.com/sakil2171' className='flex items-center gap-2'>
                                <FaFacebook className='text-4xl'></FaFacebook>
                                <p className='font-bold hover:underline opacity-90'>SakiL Ahmed</p>
                            </Link>

                            <Link to='https://github.com/Sakil71' className='flex items-center gap-2'>
                                <FaGithub className='text-4xl'></FaGithub>
                                <p className='font-bold hover:underline opacity-90'>Shakil Ahamed</p>
                            </Link>

                            <Link to='https://www.linkedin.com/in/shakil-ahamed-097164177/' className='flex items-center gap-2'>
                                <FaLinkedin className='text-4xl'></FaLinkedin>
                                <p className='font-bold hover:underline opacity-90'>Shakil Ahamed</p>
                            </Link>

                            <Link to='https://wa.me/+8801794267010?text=Hello,' className='flex items-center gap-2'>
                                <FaWhatsapp className='text-4xl'></FaWhatsapp>
                                <p className='font-bold hover:underline opacity-90'>+880 1794267010</p>
                            </Link>
                        </div>
                    </div>


                </div>
            </div>
            <div className='flex justify-center'>
                <button className='flex items-center gap-2 btn bg-teal-300 border-none font-bold' onClick={handlePrint}>Download <MdOutlineFileDownload className='text-xl animate-bounce'></MdOutlineFileDownload></button>
            </div>
        </div>
    );
};

export default ReactPdf;